module.exports = __webpack_public_path__ + "img/montserrat-majuscules.4400cc71.jpg";